<template>
    <div class="contact-result ">
	  	<div class="panel panel-default">
	  		<div class="panel-heading dash-bg-color-skin-light-10">
	    		<div class="col-xs-2 pull-left align-left head-left">
	    			<div class="rec" v-show="pcDisp"></div>
            <i  v-show="!pcDisp" class="fa fa-search cursor-pointer" aria-hidden="true" @click="receivedMultiSelect()"></i>
	    		</div>
          <div class="col-xs-8 pull-left align-center head-center">
            <div class="contactlabel"> {{ labels[nowLang].contactLabel }} </div>
          </div>
          <div class="col-xs-2 pull-right align-right head-right">
              <i class="fa fa-refresh cursor-pointer" aria-hidden="true" @click="refresh()"></i>
          </div>
          <div class="col-xs-2 pull-right align-right head-right"  v-show="pcDisp">
              <i class="fa fa-search cursor-pointer" aria-hidden="true" @click="receivedMultiSelect()"></i>
          </div>
	    	</div>

		    <div class="panel-body1">
		    	<table class="table">
			      <tbody>
              <template v-if="contactsRows.length > 0">
                <tr class="pc-big-list cursor-pointer" v-for="(contact, index) in contactsRows" @click="getContact(contact)" :key="index">
                  <td class="pc-big-fav">
                    <contact-fav v-model="contact.codempfav" :postContactFavorite="postContactFavorite" :codempid="contact.codempid" @click.stop></contact-fav>
                  </td>
                  <td class="pc-big-img">
                    <template v-if="contact.image_path !== ''">
                      <img class="img-circle" :src="baseURL + contact.image_path">
                    </template>
                    <template v-else>
                      <img class="img-circle" src="~static/images/employee/no_image.png">
                    </template>
                  </td>
                  <td class="pc-big-text">
                    <div class="name dash-color-skin">{{ contact.desc_codempid }}</div>
                    <div class="company">{{ contact.desc_codcomp }}</div>
                    <div class="position">{{ contact.desc_codpos }}</div>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr></tr>
              </template>
			      	<hrms-infinite-loading v-if="triggerContactInfiniteBool" @infinite="onInfinite" ref="contactsLoading" />
			      </tbody>
			   </table>
		    </div>
	  	</div>
	</div>
</template>

<script>
import contactFav from 'components/contact/contactFav'

export default {
  name: 'contact-list',
  data () {
    return {
      contactsRows: [],
      page: 1,
      limit: 10
    }
  },
  watch: {
    triggerResetBool () {
      if (this.triggerResetBool) {
        this.contactsRows = []
        this.page = 1
        this.limit = 10
        this.$refs.contactsLoading.$emit('$InfiniteLoading:reset')
        this.$emit('disableTriggerResetBool')
      }
    }
  },
  methods: {
    onInfinite ($state) {
      this.receivedContactsInfiniteLoading(this.params($state))
      this.page++
    },
    params ($state) {
      return {
        searchParams: {
          p_desc_codempid: this.searchParams.p_desc_codempid,
          p_desc_codcomp: this.searchParams.p_desc_codcomp,
          p_desc_codpos: this.searchParams.p_desc_codpos,
          p_page: this.page,
          p_limit: this.limit,
          p_first_load: this.searchParams.p_first_load
        },
        $state: $state,
        triggerInfinite: this.triggerInfinite
      }
    },
    triggerInfinite ({ data, $state }) {
      if (data.rows.length) {
        this.contactsRows = this.contactsRows.concat(data.rows)
        $state.loaded()
      } else {
        $state.complete()
      }
    },
    refresh () {
      this.contactsRows = []
      this.$set(this.searchParams, 'p_desc_codempid', '')
      this.$set(this.searchParams, 'p_desc_codcomp', '')
      this.$set(this.searchParams, 'p_desc_codpos', '')
      this.$set(this.searchParams, 'p_first_load', 'Y')
      this.page = 1
      this.limit = 10
      this.$nextTick(function () {
        this.$refs.contactsLoading.$emit('$InfiniteLoading:reset')
      })
    }
  },
  props: [ 'labels', 'getContact', 'searchParams', 'postContactFavorite', 'receivedContactsInfiniteLoading', 'toggle', 'receivedMultiSelect', 'pcDisp', 'triggerContactInfiniteBool', 'triggerResetBool', 'nowLang', 'baseURL' ],
  components: {
    contactFav
  }
}
</script>



// WEBPACK FOOTER //
// contactList.vue?5edec6b2